// The history list's order, as the API sorts it: pinned first, then newest.
import type { ChatConversationSummary } from '@/services/chatConversations';

const timestamp = (value: string | null): number => {
  const parsed = value ? Date.parse(value) : Number.NaN;
  return Number.isFinite(parsed) ? parsed : 0;
};

/** Mirrors the API ordering after optimistic metadata updates. */
export const sortConversationSummaries = (
  summaries: ChatConversationSummary[]
): ChatConversationSummary[] =>
  [...summaries].sort((left, right) => {
    if (Boolean(left.pinnedAt) !== Boolean(right.pinnedAt)) {
      return left.pinnedAt ? -1 : 1;
    }

    const leftTime = timestamp(left.pinnedAt ?? left.lastMessageAt);
    const rightTime = timestamp(right.pinnedAt ?? right.lastMessageAt);
    return rightTime - leftTime;
  });
